<template>
  <div class="code-action-box">
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="400px"
      :before-close="handleClose"
      :close-on-click-modal="false"
      class="el-dialogs"
    >
      <el-form ref="form" :model="params" :rules="rules" label-width="100px">
        <el-form-item label="期号:" prop="date">
          <el-date-picker v-model="params.date" type="date" placeholder="选择日期"></el-date-picker>
        </el-form-item>
        <el-form-item label="用户id:" prop="userId">
          <el-input v-model.number="params.userId" size="small" placeholder="用户"></el-input>
        </el-form-item>
        <el-form-item label="用户昵称:" prop="userName">
          <el-input v-model="params.userName" type="userName" placeholder="用户昵称"></el-input>
        </el-form-item>
        <el-form-item label="用户头像:" prop="userLogo">
          <el-input v-model="params.userLogo" type="userLogo" placeholder="用户头像"></el-input>
        </el-form-item>
        <el-form-item label="购买份数:" prop="quantity">
          <el-input v-model.number="params.quantity" placeholder="购买份数"></el-input>
        </el-form-item>

        <!-- <el-form-item label="中奖号码:" prop="winNum">
          <el-input v-model.number="params.winNum" placeholder="中奖号码"></el-input>
        </el-form-item>-->
        <el-form-item label="模特id:" prop="modelId">
          <el-input v-model.number="params.modelId" placeholder="模特id"></el-input>
        </el-form-item>
        <el-form-item label="创建时间:" prop="createdAt">
          <el-date-picker v-model="params.createdAt" type="datetime" placeholder="选择日期时间"></el-date-picker>
        </el-form-item>
        <el-form-item label="更新时间:" prop="updatedAt">
          <el-date-picker v-model="params.updatedAt" type="datetime" placeholder="选择日期时间"></el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')" :loading="flag" size="small">确 认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import moment from "moment";
import API from "@/api";
export default {
  data() {
    return {
      // 外层弹出框
      dialogVisible: false,
      title: "",
      // 提交按钮状态
      flag: false,
      // 内层弹窗表格加载状态
      loading: false,
      id: "",
      type: "",
      params: {
        date: "",
        userId: "",
        userName: "",
        userLogo: "",
        quantity: "",
        modelId: "",
        createdAt: "",
        updatedAt: "",
      },

      rules: {
        //   date: [
        //     { required: true, message: '日期', trigger: 'blur' }
        //   ],
        //   userId: [
        //     { required: true, message: '用户id', trigger: 'blur' }
        //   ],
        //   userName: [
        //     { required: true, message: '用户昵称', trigger: 'blur' }
        //   ],
        //   userLogo: [
        //     { required: true, message: '用户头像', trigger: 'blur' }
        //   ],
        //   winNum: [
        //     { required: true, message: '请选择生效时间', trigger: 'blur' }
        //   ],
        //   invalidAt: [
        //     { required: true, message: '请失效时间', trigger: 'blur' }
        //   ],
        //   // batchNum: [
        //   //   { required: true, message: '请输入批次号', trigger: 'blur' }
        //   // ],
        //   channel: [
        //     { required: true, message: '请选择渠道', trigger: 'change' }
        //   ],
        //   count: [
        //     { required: true, message: '请输入兑换码生成数量', trigger: 'blur' }
        //   ]
      },
    };
  },

  methods: {
    // 数据提交验证
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.flag = true;
          if (this.type === "add") {
            this.addWinRecord();
          } else if (this.type === "edit") {
            this.editWinRecord();
          }
        } else {
          return false;
        }
      });
    },
    // 新增兑换码
    addWinRecord() {
      let newTime = moment(this).format().slice(0, 19) + "+08:00";
      let params = Object.assign({}, this.params, { date: newTime });
      API.addWinRecord(params)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "新增成功！",
              type: "success",
            });
            this.$emit("handlerCodeList");
          } else {
            if (res.tip) {
              this.$message.error(this.tip);
            } else {
              this.$message.error("新增失败！");
            }
          }
          this.handleClose();
          this.flag = false;
        })
        .catch(() => {
          this.flag = false;
          this.handleClose();
        });
    },
    // 修改兑换码
    editWinRecord() {
      let newTime = moment(this).format().slice(0, 19) + "+08:00";

      let params = Object.assign({}, this.params, {
        id: this.id,
        date: newTime,
      });

      API.addWinRecord(params)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "修改成功！",
              type: "success",
            });
            this.$emit("handlerCodeList");
          } else {
            if (res.tip) {
              this.$message.error(this.tip);
            } else {
              this.$message.error("修改失败！");
            }
          }
          this.handleClose();
          this.flag = false;
        })
        .catch(() => {
          this.flag = false;
          this.handleClose();
        });
    },

    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.params = {
        date: "",
        userId: "",
        userName: "",
        userLogo: "",
        quantity: "",
        modelId: "",
        createdAt: "",
        updatedAt: "",
      };
      this.$refs.form.resetFields();
    },
    // 打开编辑视频弹窗、传递需要编辑的参数
    open(type, data) {
      this.dialogVisible = true;
      if (type === "add") {
        this.type = "add";
        this.title = "添加购买列表";
      } else {
        this.type = "edit";
        this.title = "修改购买列表";
        this.id = data.id;
        this.params = {
          date: data.date,
          userId: data.userId,
          userName: data.userName,
          userLogo: data.userLogo,
          quantity: data.quantity,
          modelId: data.modelId,
          createdAt: data.createdAt,
          updatedAt: data.updatedAt,
        };
      }
    },
  },
};
</script>

<style lang="scss">
agent-action-box {
  .checked {
    margin-left: 10px;
  }
}
</style>
